// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,\nbody {\n  height: 100%; /*both html and body*/\n}\nbody {\n  margin: 0; /*reset default margin*/\n  background-color: #f8f9fa;\n}\n", ""]);
// Exports
module.exports = exports;
